<template>
  <el-card>
    <!-- 查询表单 -->
    <el-form :inline="true" :model="searchFactor" class="search-form">
      <el-form-item label="模块名称:" >
        <el-input v-model="searchFactor.moduleName"></el-input>
      </el-form-item>
      <el-form-item label="实验室准入教程:" >
        <el-select v-model="searchFactor.basicState" placeholder="请选择" style="width:200px">
          <el-option  label= "全部" value="" ></el-option>
          <el-option  label= "是" value="1" ></el-option>
          <el-option  label= "否" value="0" ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSearch">查询</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleCreateQm">创建</el-button>
      </el-form-item>
    </el-form>
    <el-table
    :data="tableData"
    :stripe ="true"
    :border = "true"
    height="calc(100vh - 200px)"
    max-height="calc(100vh - 200px)"
    :highlight-current-row ="true"
    :header-cell-style="{'text-align':'center'}"
    :cell-style="{'text-align':'center'}"
      style="width: 100%">
    <el-table-column
      type="index"
      label="序号"
      :index="indexMethod">
    </el-table-column>
    <el-table-column
      prop="moduleName"
      label="模块名称"
      min-width="120" >
    </el-table-column>
    <el-table-column
        prop="basicState"
        label="实验室准入教程"
        min-width="70">
        <template slot-scope="scope">
          <span v-if = "scope.row.basicState == 1" style="color: greenyellow"> 是</span>
          <span v-else style="color: red" > 否</span>
        </template>
      </el-table-column>
    <el-table-column min-width="150px" prop="picture" label="封面">
        <template slot-scope="scope">
          <img :src="scope.row.coverImage" fit="fill"  height="100"/>
        </template>
      </el-table-column>
    <el-table-column
    prop="active"
    width="70"
    label="状态" >
    <template slot-scope="scope">
        <span v-if = "scope.row.active == 0" style="color: red"> 未发布</span>
        <span v-else style="color: greenyellow" > 已发布</span>
    </template>
  </el-table-column>
    <el-table-column
      prop="createUser"
      label="创建者"
      min-width="120">
    </el-table-column>
    <el-table-column
      prop="createTime"
      label="创建时间"
      min-width="100">
    </el-table-column>
    <el-table-column
      prop="updateUser"
      min-width="120"
      label="更新者">
    </el-table-column>
    <el-table-column
      prop="updateTime"
      min-width="100"
      label="更新时间">
    </el-table-column>
    <el-table-column label="操作" min-width="140px">
      <template slot-scope="scope"  >
          <el-dropdown split-button type="primary" @command="handleCommand">
            管理
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item divided :command = '{event:"doActiveQm",index:scope.$index, data:scope.row}'>
                <i :class="scope.row.active == 0 ? 'el-icon-star-on':'el-icon-star-off' "  :style="scope.row.active == 0 ?'color:rgb(40, 238, 10)' :'color:rgb(246, 102, 18)'" ></i> 
                <span>{{scope.row.active == 0?'发布':'撤销'}}</span>
              </el-dropdown-item>
              <el-dropdown-item divided :command = '{event:"handleEditQm",index:scope.$index, data:scope.row}'><i class="el-icon-edit" style="color:rgb(41, 10, 239)" ></i> <span>编辑</span></el-dropdown-item>
              <el-dropdown-item divided :command = '{event:"handleDelete", index:scope.$index,data:scope.row}'><i class="el-icon-delete-solid" style="color:rgb(246, 102, 18)" ></i> <span>删除</span></el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
    </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="total,prev, pager, next"
      @current-change="handleCurrentChange"
      :current-page.sync="pager.currentPage"
      :page-size="pager.pageSize"
      :total="pager.totalCount" style="margin:10px">
    </el-pagination>

    <!-- 创建知识模块弹窗 -->
    <el-dialog :close-on-click-modal="false"  :visible.sync="dialogVisual.initQmVisual" v-on:close ="clearInitQmForm" >
      <div slot="title" class="dialog-header">
          <span> 创建一个知识模块 </span>
      </div>
      <el-form :model="fileUpload" label-width="20%">
        <el-form-item  label="知识模块名称:" style="width:80%" >
          <el-input  v-model="fileUpload.moduleName" autocomplete="off" ></el-input>
        </el-form-item>
        <el-form-item  label="封面图片:" style="width:80%" >
          <el-upload 
            class="uploadImag"
            :ref="fileUpload.refElUpload"    
            :action= "fileUpload.url"
            :multiple="false" 
            :limit="1"
            :auto-upload="false" 
            list-type="picture-card">
            <i slot="default" class="el-icon-plus"></i>
            <div slot="file" slot-scope="{file}">
              <img class="el-upload-list__item-thumbnail" :src="file.url" alt  />
              <span class="el-upload-list__item-actions">
                <span
                  class="el-upload-list__item-delete"
                  @click="handleRemove(file,fileUpload.refElUpload)">
                  <i class="el-icon-delete"></i>
                </span>
              </span>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="实验室准入教程:" style="width: 80%">
          <el-checkbox v-model="fileUpload.basicState">是</el-checkbox>
        </el-form-item>
      
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="ensureCreate">创建</el-button>
      </div>
    </el-dialog>

    <!-- 更新知识模块弹窗 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="dialogVisual.editQmVisual" v-on:close ="clearEditQmForm" >
      <div slot="title" class="dialog-header">
          <span> 更新安全知识模块 </span>
      </div>
      <el-form :model="fileUpload" label-width="20%">
        <el-form-item  label="知识模块名称:" style="width:90%" >
          <el-input  v-model="fileUploadEdit.moduleName" autocomplete="off" ></el-input>
        </el-form-item>
        <el-form-item label="更新封面:" style="width:90%">
          <el-switch
            v-model="fileUploadEdit.updateImage"
            active-text="是"
            inactive-text="否" @change="funcUpdateImageChange">
          </el-switch>
        </el-form-item>
        <el-form-item  label="封面图片:" style="width:90%" >
          <el-upload 
            class="uploadImagEdit"
            :ref="fileUploadEdit.refElUpload"    
            :action= "fileUploadEdit.url"
            :multiple="false"
            :limit="1"
            :file-list="fileUploadEdit.fileListAdd"
            :auto-upload="false" 
            list-type="picture-card">
            <i slot="default" class="el-icon-plus"></i>
            <div slot="file" slot-scope="{file}">
              <img class="el-upload-list__item-thumbnail" :src="file.url" alt  />
              <span class="el-upload-list__item-actions">
                <span
                  class="el-upload-list__item-delete"
                  @click="handleRemove(file,fileUploadEdit.refElUpload)">
                  <i class="el-icon-delete"></i>
                </span>
              </span>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item style="width:90%"  label="实验室准入教程:" >
          <el-checkbox disabled v-model="fileUploadEdit.basicState"></el-checkbox>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="ensureUpdate">确定更新</el-button>
      </div>
    </el-dialog>
  </el-card>
</template>                     
<script>
  // 引入组件

  import axios from  '@/api/axiosConfig'
  import {stringIsNullOrEmpty,getToken} from  '@/api/utils'
  import {PAGE_SIZE,MESSAGE_DURATION} from  '@/api/constant'
  export default {
      name : 'pc_ctr_qm_list',
      data() {
      return {
        searchFactor: {
          moduleName: '',
          basicState : ''
        },
        dialogVisual:{
          initQmVisual: false,
          editQmVisual : false
        },
        tableData: [],
        pager:{
          currentPage:'',
          totalCount:0,
          pageSize : PAGE_SIZE
        },
        tokenObj:{
          token :''
        },
        fileUpload :{
          refElUpload : 'uploadRef',
          url :"",
          moduleName:'',
          basicState : false,
          param: new FormData() //图片上传相关
        },
        fileUploadEdit :{
          refElUpload: 'uploadImagEdit',
          url :"",
          updateImage : false,
          moduleName:'',
          fileListAdd:[],
          row : ''
        }
      }
    },
    methods : {
      handleCommand(command){
        let index  = command.index
        let row = command.data
        let event = command.event
        switch(event){
          case 'handleDelete':
            this.handleDelete(index,row)
            break
          case 'handleEditQm':
            this.handleEditQm(index,row)
            break
          case 'doActiveQm':
            this.doActiveQm(index,row)
            break
        }
      },
      ensureCreate(){
        let fileList = []
        try{ 
          let fileRef = this.$refs[this.fileUpload.refElUpload]
          if(fileRef == null ){
            throw "请上传知识模块封面图片!"
          }
          fileList = fileRef.uploadFiles
          if(fileList == null || fileList.length == 0) {
            throw "请上传知识模块封面图片!"
          }
          stringIsNullOrEmpty(this.fileUpload.moduleName ,'请输入模块名称!');
        }catch (e){
          this.$message({
            showClose: true,
            message: e,
            type: 'error',
            duration: MESSAGE_DURATION
          }) 
          return
        }
        if( this.fileUpload.param.has('file')){
          this.fileUpload.param.delete('file')
        }

        if(this.fileUpload.param.has('moduleName')){
          this.fileUpload.param.delete('moduleName')
        }
        if(this.fileUpload.param.has('basicState')){
          this.fileUpload.param.delete('basicState')
        }
        this.fileUpload.param.append("moduleName", this.fileUpload.moduleName )
        this.fileUpload.param.append('file',fileList[0].raw)
        this.fileUpload.param.append('basicState', this.fileUpload.basicState ? 1: 0 )
        let url = "/bc/exa/qm/uploadFileAndInit"
        axios.post(url, this.fileUpload.param,{
          headers: {
            'Content-Type': 'multipart/form-data',
            'token': this.tokenObj.token
          }
        }).then((response) => {
          if (response.data.code === 0){
            this.dialogVisual.initQmVisual = false;
            this.$message({
              showClose: true,
              message: '初始化安全知识模块成功',
              type: 'success',
              duration: MESSAGE_DURATION
            })
            this.clearInitQmForm();
            this.qmListLoad(1);
          } else {
            this.$message({
              showClose: true,
              message: response.data.message,
              type: 'error',
              duration: MESSAGE_DURATION
            })
          }
        }).catch( (err)=> {
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            duration: MESSAGE_DURATION
          }) 
        })
      },
      ensureUpdate(){
        let  fileList = []
        try{ 
          if(this.fileUploadEdit.updateImage){
            let fileRef = this.$refs[this.fileUploadEdit.refElUpload]
            if(fileRef == null ){
              throw "请上传知识模块封面图片!"
            }
            fileList = fileRef.uploadFiles
            if(fileList == null || fileList.length == 0) {
              throw "请上传知识模块封面图片!"
            }
          }else{
            stringIsNullOrEmpty(this.fileUploadEdit.moduleName ,'请输入模块名称!');
          }
        }catch (e){
          this.$message({
            showClose: true,
            message: e,
            type: 'error',
            duration: MESSAGE_DURATION
          }) 
          return
        }
        let data = new FormData()
        data.append("id", this.fileUploadEdit.row.id)
        if(this.fileUploadEdit.updateImage){
          data.append('file', fileList[0].raw)
        }
        data.append("moduleName", this.fileUploadEdit.moduleName)
        let url = "/bc/exa/qm/update"
        axios.post(url, data,{
          headers: {
            'Content-Type': 'multipart/form-data',
            'token': this.tokenObj.token
          }
        }).then((response) => {
          if (response.data.code === 0){
            this.dialogVisual.editQmVisual = false;
            this.$message({
              showClose: true,
              message: '更新安全知识模块成功',
              type: 'success',
              duration: MESSAGE_DURATION
            })
            this.clearEditQmForm()
            setTimeout(()=>{this.qmListLoad(1)},200)
          
          } else {
            this.$message({
              showClose: true,
              message: response.data.message,
              type: 'error',
              duration: MESSAGE_DURATION
            })
          }
        }).catch( (err)=> {
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            duration: MESSAGE_DURATION
          }) 
        })
      },
      // 添加一个图片
      handleAddChange(file, fileList) {
        if(this.fileUpload.fileListAdd.length >1){
          this.$message({
            showClose: true,
            message: "封面只能上传一个！",
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }else{
          this.fileUpload.fileListAdd.push(file)
        }
      },

      
      indexMethod(index){
          return  index + 1
      },
      
      formatContent(row , index){
        if(row.content == null || row.content == ''){
          return ''
        }
        if(row.content.length > 400 ){
          return row.content.substring(0,400)
        }
        return row.content
      },
      handleCurrentChange(val){
        this.qmListLoad(val);
      },
      qmListLoad(pageNo){
        let url = "/bc/exa/qm/qmPage"
        let { 
          moduleName,
          basicState,
        } = this.searchFactor 
        let dat0 = {
            pageSize: PAGE_SIZE,
            moduleName,
            pageNo,
            basicState
        }
        axios.post(url, dat0).then((response) => {
          if (response.data.code === 0) {
            let dat = response.data.data;
            if(dat.data.length !== 0){
                this.tableData = [];
                dat.data.forEach(t=>this.tableData.push(t))
                this.pager.totalCount = dat.totalDataCount;
                if(pageNo == 1 ) {
                  this.pager.currentPage = 1
                }
            } else {
              this.$message({
                showClose: true,
                message: '未查询到安全知识信息！',
                type: 'info',
                duration: MESSAGE_DURATION
              })
            }
          }else{
            this.$message({
              showClose: true,
              message: response.data.message,
              type: 'error',
              duration: MESSAGE_DURATION
            })
          }
          }).catch((err)=>{
            this.$message({
              showClose: true,
              message: err.message,
              type: 'error',
              duration: MESSAGE_DURATION
            })
          });
      },
      onSearch(){
        this.qmListLoad(1)
      },
      handleCreateQm(){
        this.dialogVisual.initQmVisual = true;
      },
      handleDelete(index, row){
        this.$confirm('即将删除主题['+row.moduleName+']的安全知识!', '提示', {
          cancelButtonText: '取消',
          confirmButtonText: '确定',
          type: 'warning'
        }).then(() => {
          this.doDeleteQm(row)
        }).catch((err) => {
          this.$message({
            type: 'info',
            message: err.message
          });
        })
      },
      doDeleteQm(row){
        let datBat = {id: row.id}
        let url = "/bc/exa/qm/qmDelete"
        let s = JSON.stringify(datBat)  
        axios.post(url, s).then((response) => {
          if (response.data.code === 0){
            this.$message({
              showClose: true,
              message: '删除成功!',
              type: 'success',
              duration: MESSAGE_DURATION
            })
            this.qmListLoad(1);
          } else {
            this.$message({
              showClose: true,
              message: response.data.message,
              type: 'error',
              duration: MESSAGE_DURATION
            })
          }
        }).catch( (err) => {
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            duration: MESSAGE_DURATION
          }) 
        })
      },
      doActiveQm(index,row){
        let actState = row.active === 0 ? 1 : 0
        let dat = {
          id: row.id,
          active: actState
        }
        let url = "/bc/exa/qm/qmActive"
        let s = JSON.stringify(dat)  
        axios.post(url, s).then((response) => {
          if (response.data.code === 0){
            this.$message({
              showClose: true,
              message: '操作成功!',
              type: 'success',
              duration: MESSAGE_DURATION
            })
            this.qmListLoad(1);
          } else {
            this.$message({
              showClose: true,
              message: response.data.message,
              type: 'error',
              duration: MESSAGE_DURATION
            })
          }
        }).catch( (err) => {
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            duration: MESSAGE_DURATION
          }) 
        })
      },
      clearInitQmForm(){
        this.fileUpload.moduleName = ''
        this.fileUpload.basicState = false
        let fileRef = this.$refs[this.fileUpload.refElUpload]
        if(fileRef != null){
          fileRef.clearFiles()
        }     
      },
      handleEditQm(index,row){
        this.fileUploadEdit.row = row
        this.fileUploadEdit.moduleName = row.moduleName
        this.fileUploadEdit.fileListAdd.push({name:row.id,url:row.coverImage})
        this.dialogVisual.editQmVisual = true
        this. fileUploadEdit. basicState = row.basicState == 1
      },
      handleRemove(file,refElUpload) { 
        let fileList = this.$refs[refElUpload].uploadFiles
        let index = fileList.indexOf(file)
        this.$refs[refElUpload].uploadFiles.splice(index,1)
      },
      funcUpdateImageChange(){
        let row = this.fileUploadEdit.row
        let rawHasFile = false
        if(row != null && row != '' && row.coverImage != null &&row.coverImage != '' ){
          rawHasFile = true
        }
        if(this.fileUploadEdit.updateImage){
          if( this.$refs[this.fileUploadEdit.refElUpload] != null){
            this.$refs[this.fileUploadEdit.refElUpload].clearFiles()
          }
          if(rawHasFile){
            this.fileUploadEdit.fileListAdd.splice(0)
          }
        }else{
          if(rawHasFile){
            this.fileUploadEdit.fileListAdd.push({name:row.id, url:row.coverImage})
          }
        }
    },
    clearEditQmForm(){
      this.fileUploadEdit.updateImage = false
      this.fileUploadEdit.row = ''
      this.fileUploadEdit.moduleName = ''
      this.fileUploadEdit.fileListAdd.splice(0)
      let fileRef =  this.$refs[this.fileUploadEdit.refElUpload]
      if(fileRef != null ){
        fileRef.clearFiles()
      }
    }
  },
  created () {
    setTimeout(()=>{getToken(this.tokenObj)},200)
    this.qmListLoad(1);
  }
}

</script>
<style lang="less" scoped>
.el-card {
  height: 99%
}

.search-form{
  margin-top: 10px;
  text-align:left 
}
</style>
    


// WEBPACK FOOTER //
// src/pc_pages/pc_ctr_component/pc_ctr_qm_list.vue